module.exports = __webpack_public_path__ + "static/media/featureResponsible_illust.2113dea7.jpg";